import matchesCondition from './matchesCondition';

/**
 * The flat fields of a form whose show condition is met by the answers, keyed by field name.
 * Like the survey, a condition only sees the answers of the fields shown before it.
 */
export default function getVisibleFieldsFromForm(
    form: Form | null,
    answers: Record<string, unknown> | null,
): FormField[] {
    const { fields = [] } = form || {};
    const visibleAnswers: Record<string, unknown> = {};
    const getVisibleFields = (allFields: FormField[]): FormField[] =>
        allFields.reduce<FormField[]>((acc, field) => {
            const { type, name, showWhen = null } = field;
            if (!matchesCondition(showWhen, visibleAnswers)) {
                return acc;
            }
            if (type === 'group') {
                return [...acc, ...getVisibleFields((field as GroupField).fields)];
            }
            visibleAnswers[name] = answers !== null ? answers[name] : null;
            return [...acc, field];
        }, []);
    return getVisibleFields(fields);
}
